/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IEngagementsOrdersByPeriodItem } from 'pages/Dashboard/Dashboard.models';
// eslint-disable-next-line no-unused-vars
import { TPeriod } from 'shared/CustomRangePicker/CustomRangePicker.models';
import { getEngagementsOrdersTOByPeriod } from './api.service';

export interface IState {
  data: IEngagementsOrdersByPeriodItem[];
  isLoading: boolean;
  error: object | null;
}

const initialState: IState = {
  data: [],
  error: null,
  isLoading: false,
};

export const getEngagementsOrdersTOByPeriodAction = createAsyncThunk(
  'getEngagementsOrdersTOByPeriodAction',
  async (
    { controller, params }: {params: TPeriod, controller: AbortController},
    { rejectWithValue },
  ) => {
    const { signal } = controller;

    try {
      const { data } = await getEngagementsOrdersTOByPeriod(signal, params);
      return data;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const EngagementsOrdersTOByPeriodSlice = createSlice({
  name: 'getEngagementsOrdersTOByPeriod',
  initialState,
  reducers: {
    clear: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(getEngagementsOrdersTOByPeriodAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getEngagementsOrdersTOByPeriodAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getEngagementsOrdersTOByPeriodAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
        state.data = [];
      });
  },
});

export const {
  clear: clearEngagementsOrdersTOByPeriodAction,
} = EngagementsOrdersTOByPeriodSlice.actions;

export const getEngagementsOrdersTOByPeriodReducer = EngagementsOrdersTOByPeriodSlice.reducer;
